import { localeLanguages as e } from "./locale-labels.mjs";
import { LanguageCodeEnum as t, LocaleEnum as n } from "@systemeio/types";
//#region src/translations/language-utils.ts
function r(e) {
	let r = Object.keys(n).find((t) => n[t] === e);
	return r ? t[r] : t.ENGLISH;
}
function i(e) {
	let r = Object.keys(t).find((n) => t[n] === e);
	return r ? n[r] : n.ENGLISH;
}
function a(t, n) {
	return n(e[t]);
}
//#endregion
export { r as getLanguageCodeByLocale, i as getLocaleByLanguageCode, a as getLocaleLanguage };
